import Vue from 'vue'

Vue.filter('currency', function (value, decimals) {
  decimals = isNaN(decimals = Math.abs(decimals)) ? 0 : decimals
  var i = String(parseInt(value = Math.abs(Number(value) || 0).toFixed(decimals)))
  var j = (j = i.length) > 3 ? j % 3 : 0
  return '$' + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + ',') + (decimals ? '.' + Math.abs(value - i).toFixed(decimals).slice(2) : '')
})

Vue.filter('capitalize', function (value) {
  return value.charAt(0).toUpperCase() + value.slice(1)
})



// WEBPACK FOOTER //
// ./src/global-filters.js